export { default as PlaceholderContainer } from 'placeholders/PlaceholderContainer';
export { default as PlaceholderBooking } from 'placeholders/PlaceholderBooking';
export { default as PlaceholderCalendarStrip } from 'placeholders/PlaceholderCalendarStrip';
export { default as PlaceholderUserCard } from 'placeholders/PlaceholderUserCard';
export { default as PlaceholderBuildingBar } from 'placeholders/PlaceholderBuildingBar';
export { default as PlaceholderMessage } from 'placeholders/PlaceholderMessage';
export { default as PlaceholderText } from 'placeholders/PlaceholderText';
